<template>
  <div>
    <b-row>
      <!-- {{ field }} -->
      <b-col>
        <label v-if="field.tipo == 8">
          <span style="white-space: pre">
            {{ field.defaultValue }}
          </span>
        </label>
        <div v-if="field.tipo == 7">
          <b-row class="mt-3">
            <b-button v-if="!isCheckedSomeValue" size="sm" @click="checkAll">
              {{ $t("geral.checkAll") }}
            </b-button>
            <b-button v-else size="sm" @click="uncheckAll">
              {{ $t("geral.uncheckAll") }}
            </b-button>
          </b-row>

          <b-row>
            <b-col sm="4" md="3">
              <label class="mb-2 mt-2">Agendar</label>
            </b-col>
            <b-col>
              <label class="mb-2 mt-2">{{ field.nome }}</label>
            </b-col>
          </b-row>

          <b-row
            v-for="field in valuesToSchedule"
            :key="field.value"
            class="mb-3 mt-3"
          >
            <b-col sm="4" md="3">
              <b-form-select
                :id="'checkbox-' + field.value"
                :options="optionsBoolean"
                v-model="field.schedule"
                v-on:change="onDataChange(field)"
                style="max-width='100px'"
                :disabled="readonly"
              >
              </b-form-select>
            </b-col>
            <b-col>
              <input
                type="text"
                class="form-control"
                :value="field.value"
                readonly
              />
            </b-col>
          </b-row>
        </div>
        <ValidationProvider
          v-else
          v-for="schedulerField in valuesToSchedule"
          :key="schedulerField.value"
          :name="getFieldIdInputName"
          rules="required"
          v-slot="{ validate, passed }"
        >
          <div :class="[{ 'has-success': passed }]">
            <b-form-group
              :label="'Campo de busca: ' + field.nome"
              :label-for="getFieldIdInputName"
              :placeholder="field.dica"
            >
              <b-input-group>
                <!-- Booleano -->
                <b-form-select
                  v-if="field.tipo == 1"
                  @input="validate"
                  :id="getFieldIdInputName"
                  :options="optionsBoolean"
                  v-model="schedulerField.value"
                  :readonly="readonly"
                >
                  <template v-slot:first>
                    <b-form-select-option field selected disabled>
                      {{ field.dica }}
                    </b-form-select-option>
                  </template>
                </b-form-select>

                <!-- Data -->
                <b-form-input
                  v-if="field.tipo == 2"
                  @input="validate"
                  type="date"
                  :id="getFieldIdInputName"
                  :placeholder="field.dica"
                  v-model="schedulerField.value"
                  :debounce="inputChangeDebounce"
                  :readonly="readonly"
                />

                <!-- Hora -->
                <!-- <b-form-timepicker :id="getFieldIdInputName" v-model="schedulerField.value"></b-form-timepicker> -->
                <b-form-input
                  v-if="field.tipo == 3"
                  @input="validate"
                  type="time"
                  :id="getFieldIdInputName"
                  :placeholder="field.dica"
                  v-model="schedulerField.value"
                  :debounce="inputChangeDebounce"
                  :readonly="readonly"
                />

                <!-- Decimal -->
                <b-form-input
                  v-if="field.tipo == 4"
                  @input="validate"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.dica"
                  v-model="schedulerField.value"
                  v-mask="'money'"
                  :debounce="inputChangeDebounce"
                  :readonly="readonly"
                />

                <!-- Inteiro -->
                <b-form-input
                  v-if="field.tipo == 5"
                  @input="validate"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.dica"
                  v-model="schedulerField.value"
                  v-mask="'999999999999999'"
                  :debounce="inputChangeDebounce"
                  :readonly="readonly"
                />

                <!-- Texto -->
                <b-form-input
                  v-if="field.tipo == 6"
                  @input="validate"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.dica"
                  v-model="schedulerField.value"
                  :debounce="inputChangeDebounce"
                  :readonly="readonly"
                />
              </b-input-group>
            </b-form-group>
          </div>
        </ValidationProvider>

        <span v-if="hasProblem" class="text-danger">
          {{ getProblemText }}
        </span>
      </b-col>

      <div v-if="field.allowsAttachment && field.attachment.length > 0">
        <img :src="field.attachment" style="width: 200px; height: 200px" />
      </div>

      <!-- <div>{{ modelstate }}</div> -->
      <!-- <div>{{ checklist }}</div> -->
      <!-- {{ values }} -->
    </b-row>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
extend("required", required);

import AwesomeMask from "awesome-mask";

export default {
  name: "FormSchedulerField",
  directives: {
    mask: AwesomeMask,
  },
  props: {
    field: Object,
    fieldId: Number,
    modelstate: Object,
    valuesToSchedule: Array,
    readonly: {
      type: Boolean,
      default: false,
      description: "Readonly",
    },
  },
  data: function () {
    return {
      inputChangeDebounce: 500,
      optionsBoolean: [
        { value: false, text: "Não" },
        { value: true, text: "Sim" },
      ],
    };
  },
  computed: {
    getFieldId() {
      if (this.fieldId) {
        return this.fieldId;
      }
      return 1;
    },
    getFieldIdInputName() {
      return "input" + this.getFieldId.toString();
    },
    hasProblem() {
      if (this.getProblemText()) {
        return true;
      }
      return false;
    },
    isCheckedSomeValue() {
      for (let value of this.valuesToSchedule) {
        if (value.schedule) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    checkAll() {
      for (let value of this.valuesToSchedule) {
        value.schedule = true;
      }
    },
    async onDataChange(item) {
      this.$emit("parentForceUpdate");
    },
    getProblemText() {
      if (this.modelstate) {
        let modelstateText = this.modelstate[field.fieldId.toString()];
        if (modelstateText) {
          return modelstateText;
        }
      }
      return "";
    },
    uncheckAll() {
      for (let value of this.valuesToSchedule) {
        value.schedule = false;
      }
    },
  },
};
</script>

<style>
.div-attachment-file {
  display: block;
}
.div-attachment-photo {
  display: none;
}

@media (max-width: 768px) {
  .div-attachment-file {
    display: none;
  }
  .div-attachment-photo {
    display: block;
    margin-top: -1.5rem;
  }
  .file {
    display: none;
  }
}
</style>

<style scope>
.custom-select:not(:last-child) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.custom-file-label {
  border: none;
  display: none;
}

.file {
  background: #2c3b5d;
  width: 3rem;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
</style>
